import * as moment from 'moment';

export class LocalDateFormatDetailedValueConverter {
    toView(value: Date) {
        const timestamp = moment.utc(value);
        return timestamp.year() > 1 ? timestamp.local().format('YYYY-MM-DD HH:mm:ss') : "";
    }
}